import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {},
  content: {
    marginTop: theme.spacing(10),
  },
  title: {
    color: 'gray',
    fontWeight: 600,
  },
  icon: {
    fontSize: '3em',
  },
}));

export default useStyles;
